import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Configuration for toast notifications
const toastConfig = {
  position: "top-right", // Moves toast to the middle of the top
  autoClose: 3000,
  hideProgressBar: true, // Hide progress bar for cleaner UI
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  className: "custom-toast", // Custom class for styling
};

// Success message utility
export const showSuccessToast = (message) => {
  toast.success(message, toastConfig);
};

// Error message utility
export const showErrorToast = (message) => {
  toast.error(message, toastConfig);
};

// Warning message utility
export const showWarningToast = (message) => {
  toast.warn(message, toastConfig);
};
